import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=48cc94ef&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48cc94ef')) {
      api.createRecord('48cc94ef', component.options)
    } else {
      api.reload('48cc94ef', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=48cc94ef&", function () {
      api.rerender('48cc94ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wCgR3LYWV0Q6/JS/comp/ImgFallback.vue"
export default component.exports